import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d42dac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  href: "https://prodia.com/",
  class: "logo"
}
const _hoisted_2 = { class: "main-links" }
const _hoisted_3 = { class: "secondary-links-wrapper disable-resize-transition" }
const _hoisted_4 = { class: "mobile-header-wrapper" }
const _hoisted_5 = { class: "secondary-links" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://docs.prodia.com/",
    target: "_blank",
    class: "nav-link"
  }, "Docs")
], -1))
const _hoisted_7 = { class: "fake-avatar" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "user-menu" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 3,
  class: "loading"
}

import { ref } from "vue";

import {
	email,
	plan,
	showLogoutModal,
	showAccount,
	displayPlan
} from "@/refs/account";

import { showProModal, showSignupModal, showLoginModal } from "@/refs/modals";
import { useRoute } from "vue-router";

import DarkModeToggle from "@/components/DarkModeToggle.vue";
import StyledButton from "@/components/StyledButton.vue";
import SignupModal from "@/components/SignupModal.vue";
import ProModal from "@/components/ProModal.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import Logo from "@/components/svgs/Logo.vue";
import PlaygroundIcon from "@/components/svgs/PlaygroundIcon.vue";
import ApiIcon from "@/components/svgs/ApiIcon.vue";
import MobileNav from "@/components/svgs/MobileNav.vue";
import Exit from "@/components/svgs/Exit.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const route = useRoute();
const avatarCharacter = ref(email.value?.substring(0, 1).toUpperCase());
const NavOpen = ref(false);
const UserMenuOpen = ref(false);
const toggleMobileNav = () => {
	NavOpen.value = !NavOpen.value;
};
const hideUserMenu = () => {
	UserMenuOpen.value = false;
};
const toggleUserMenu = () => {
	UserMenuOpen.value = !UserMenuOpen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("nav", {
      class: _normalizeClass(["nav", { open: NavOpen.value }])
    }, [
      _createElementVNode("div", {
        class: "mobile-nav-icon-wrapper",
        onClick: toggleMobileNav
      }, [
        _createVNode(MobileNav, { class: "mobile-nav-icon" })
      ]),
      _createElementVNode("a", _hoisted_1, [
        _createVNode(Logo)
      ]),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createVNode(PlaygroundIcon),
              _createTextVNode(" Models ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/api",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createVNode(ApiIcon),
              _createTextVNode(" API ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "close-mobile-nav",
            onClick: toggleMobileNav
          }, [
            _createVNode(Exit)
          ])
        ]),
        _createElementVNode("ul", _hoisted_5, [
          _hoisted_6,
          (_unref(showAccount) && _unref(email))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass(["user", { open: UserMenuOpen.value }])
              }, [
                _withDirectives((_openBlock(), _createElementBlock("span", {
                  class: "user-header",
                  onClick: toggleUserMenu
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(avatarCharacter.value), 1),
                  _createElementVNode("span", {
                    class: "user-header-text",
                    title: _unref(email)
                  }, _toDisplayString(_unref(email)), 9, _hoisted_8)
                ])), [
                  [_directive_click_outside, hideUserMenu]
                ]),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", {
                    class: "user-link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showProModal.value = true))
                  }, [
                    (_unref(plan) === 'free')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Upgrade"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(displayPlan)), 1))
                  ]),
                  _createElementVNode("span", {
                    class: "user-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showLogoutModal.value = true))
                  }, " Logout ")
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_unref(showAccount) && !_unref(email))
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createElementVNode("span", {
                  class: "nav-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showLoginModal.value = true))
                }, " Login ")
              ]))
            : _createCommentVNode("", true),
          (_unref(showAccount) && !_unref(email))
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createVNode(StyledButton, {
                  class: "nav-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showSignupModal.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign up")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_unref(showAccount))
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, "Loading…"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "nav-backdrop",
        onClick: toggleMobileNav
      })
    ], 2), [
      [_vShow, _unref(route).path !== '/login']
    ]),
    _createVNode(SignupModal),
    _createVNode(LogoutModal),
    _createVNode(ProModal)
  ], 64))
}
}

})